import { getOlympicBySlug } from "@/services/olympics.service";

const STATIC_CONTESTS = [
  {
    slug: "olimpiadas-mobius-2026",
    title: "Olimpiadas Mobius 2026",
    subtitle:
      "Una competencia internacional para jóvenes que disfrutan pensar, resolver y retarse",
    startAt: "Sáb, 03 May 2026 · 10:00",
    endAt: "Dom, 24 May 2026 · 18:00",
    dateRange: "Inscripción gratuita: febrero–abril",
    timezone: "GMT-05",
    countdown: "Edición 2026",
    courseId: 636,
    olympicId: null,
    prizes: [
      "1er lugar: 400 USD",
      "2do lugar: 200 USD",
      "3er lugar: 100 USD",
      "Membresías Mobius gratuitas para todos los estudiantes del colegio de los tres primeros lugares",
    ],
    rules: [
      "Participación gratuita y totalmente online.",
      "Competencia dirigida a estudiantes hispanohablantes menores de 18 años en cualquier lugar del mundo.",
      "Cada participante debe competir de forma individual, sin ayuda externa.",
      "Es obligatorio registrarse con el correo del estudiante y completar el perfil.",
    ],
    ranking: [
      "Clasificación por sistema de puntos según el examen más reciente de cada fase. Empate: menor tiempo en ese examen.",
    ],
    details:
      "La Olimpiada Mobius 2026 está diseñada para estudiantes hispanohablantes menores de 18 años de cualquier lugar del mundo.",
    phases: [],
    theme: {
      gradientStart: "#656EC9",
      gradientEnd: "#598DFF",
      accent: "#656EC9",
    },
  },
];

export const contests = STATIC_CONTESTS;

export const getContestBySlug = (slug) =>
  contests.find((contest) => contest.slug === slug);

function mergeOlympicApi(staticContest, api) {
  if (!api) return staticContest;
  return {
    ...staticContest,
    title: api.title || api.description || staticContest.title,
    description: api.description,
    longDescription: api.longDescription,
    courseId: api.moduleId || staticContest.courseId,
    olympicId: api.id,
    slug: api.slug || staticContest.slug,
    phases: (api.phases || []).map((p) => ({
      id: p.id,
      name: p.name,
      position: p.position,
      isFinal: p.isFinal,
      rankingReleased: p.rankingReleased,
      advancementType: p.advancementType,
      exams: p.exams,
    })),
  };
}

export async function loadContestBySlug(slug) {
  const staticContest = getContestBySlug(slug);
  if (!staticContest) return null;
  try {
    const { data } = await getOlympicBySlug(slug);
    return mergeOlympicApi(staticContest, data);
  } catch {
    return staticContest;
  }
}
